import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type AdjustShadingState = {
	shadingMenu: {
		open: boolean,
		segmentId: string | null,
		panelKey: string,
		isUserMapped: boolean,
		shadingVal: number,
		isShadingAdjusted: boolean,
		doneEnabled: boolean,
		azimuth: number,
		pitch: number,
		systemProduction: number,
		panelsCount: number,
		systemSize: number,
		totalPanelsProduction: number,
		totalSystemSize: number,
		totalPanelsFromFacet: number,
	},
	shadingWarningModal:{
		open: boolean;
    warningMessage: string;
	}
};

const initialState: { data: AdjustShadingState } = {
	data: {
		shadingMenu: {
			open: false,
			shadingVal: 0,
			segmentId: null,
			panelKey: '',
			isUserMapped: false,
			isShadingAdjusted: false,
			doneEnabled: false,
			azimuth: 0,
			pitch: 0,
			systemProduction: 0,
			panelsCount: 0,
			systemSize: 0,
			totalPanelsProduction: 0,
			totalSystemSize: 0,
			totalPanelsFromFacet: 0,
		},
		shadingWarningModal:{
			open: false,
			warningMessage: '',
		},
	}
};

export const AdjustShadingSlice = createSlice({
	name: 'adjustShadingMenu',
	initialState,
	reducers: {
		openShadingMenu: (state, action: PayloadAction<{ segmentId: string, shadingVal: number, panelKey: string, isUserMapped: boolean, 
				isShadingAdjusted: boolean, doneEnabled: boolean, azimuth: number, pitch: number, systemProduction: number, 
				panelsCount: number, systemSize: number, totalPanelsProduction:number, totalSystemSize: number, totalPanelsFromFacet: number }>) => {
			state.data.shadingMenu.open = true;
			state.data.shadingMenu.segmentId = action.payload.segmentId;
			state.data.shadingMenu.shadingVal = action.payload.shadingVal;
			state.data.shadingMenu.panelKey = action.payload.panelKey;
			state.data.shadingMenu.isUserMapped = action.payload.isUserMapped;
			state.data.shadingMenu.isShadingAdjusted = action.payload.isShadingAdjusted;
			state.data.shadingMenu.doneEnabled = action.payload.doneEnabled;
			state.data.shadingMenu.azimuth = action.payload.azimuth;
			state.data.shadingMenu.pitch = action.payload.pitch;
			state.data.shadingMenu.systemProduction = action.payload.systemProduction;
			state.data.shadingMenu.panelsCount = action.payload.panelsCount;
			state.data.shadingMenu.systemSize = action.payload.systemSize;
			state.data.shadingMenu.totalPanelsProduction = action.payload.totalPanelsProduction;
			state.data.shadingMenu.totalSystemSize = action.payload.totalSystemSize;
			state.data.shadingMenu.totalPanelsFromFacet = action.payload.totalPanelsFromFacet;
		},
		closeShadingMenu: (state) => {
			state.data.shadingMenu.open = false;
			state.data.shadingMenu.segmentId = null;
			state.data.shadingMenu.shadingVal = 0;
			state.data.shadingMenu.panelKey = '';
			state.data.shadingMenu.isUserMapped = false;
			state.data.shadingMenu.isShadingAdjusted = false;
			state.data.shadingMenu.doneEnabled = false;
			state.data.shadingMenu.azimuth = 0;
			state.data.shadingMenu.pitch = 0;
			state.data.shadingMenu.systemProduction = 0;
			state.data.shadingMenu.panelsCount = 0;
			state.data.shadingMenu.systemSize = 0;
			state.data.shadingMenu.totalPanelsProduction = 0;
			state.data.shadingMenu.totalSystemSize = 0;
			state.data.shadingMenu.totalPanelsFromFacet = 0;
		},
		toggleAdjustShadingWarningModal: (state, action: PayloadAction<AdjustShadingState['shadingWarningModal']>) => {
			state.data.shadingWarningModal.open = action.payload.open;
			state.data.shadingWarningModal.warningMessage = action.payload.warningMessage;
		},
		toggleShadingMenu:(state, action: PayloadAction<{ open: boolean }>) => {
			state.data.shadingMenu.open = action.payload.open;
		},
	}
});

export const { openShadingMenu, closeShadingMenu, toggleAdjustShadingWarningModal, toggleShadingMenu } = AdjustShadingSlice.actions;

export default AdjustShadingSlice.reducer;